import React from "react";

export default function AisprawlSystem() {
  return (
    <>
      <div className="dashboard-header-row d-flex flex-row flex-nowrap align-items-center mb-4 w-100">
        <h1 className="dashboard-title mb-0 flex-shrink-0">System</h1>
      </div>
    
    </>
  );
}
